import React, { useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import RoundedSearchTextField from "./RoundedSearchTextField";
import infoIcon from "../../images/infoIcon.svg";
import variables from "../../styles/base/_universal.scss";
import "./MultiSelectList.scss";

const MultiSelectList = ({
  data,
  open,
  enableSearch = true,
  handleSelection,
  selected,
  height = "100%",
  searchResults,
  inlineButton = false,
  handleSearch,
  inputValue = "",
  placeholder,
  setIsSearchBarEmpty,
}) => {
  const isSelected = (element) => {
    return selected?.findIndex((el) => element.id === el.id) > -1;
  };
  return (
    <div style={{ paddingTop: "12px", paddingRight: "6px" }}>
      {enableSearch && (
        <div style={{ margin: "0px 16px" }}>
          <RoundedSearchTextField
            onTextChange={searchResults}
            handleSearch={(type) => {
              if (inlineButton) {
                handleSearch(type);
              }
            }}
            inlineButton={inlineButton}
            inputValue={inputValue}
            placeholder={placeholder}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
          />
        </div>
      )}
      <div
        className="multi-select-list custonScrollBar"
        style={{ height: height }}
      >
        {data?.length === 0 && (
          <div
            style={{
              margin: "14px 16px",
              fontSize: variables.fontSmall,
              color: variables.grayFilterColor,
              display: "flex",
            }}
          >
            <img
              src={infoIcon}
              alt="Info"
              style={{ marginRight: "6px", marginBottom: "30px" }}
            />
            <p> No Result Found, Try Using Different Keywords</p>
          </div>
        )}

        <MenuList autoFocusItem={open} id="menu-list-grow">
          <div></div>
          {data?.map((option) => (
            <MenuItem
              key={option.id}
              onMouseDown={(e) => {
                e.preventDefault();
              }}
              //onClick={(e) => e.preventDefault()}
              onBlur={(e) => e.preventDefault()}
              onClick={(e) => {
                handleSelection(!isSelected(option), option);
              }}
              //className={`menu-items  `}
              className={`menu-items ${
                option === option?.value
                  ? "blue-background"
                  : "no-blue-background"
              }`}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    key={option.id}
                    className="checkBox"
                    onChange={(ev) => {
                      handleSelection(ev.target.checked, option);
                    }}
                    name={option.brandName || option.marketName}
                    color="primary"
                    size="small"
                    checked={isSelected(option)}
                  />
                }
                label={option.brandName || option.marketName}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
            </MenuItem>
          ))}
        </MenuList>
      </div>
    </div>
  );
};

export default MultiSelectList;
